import {type List} from 'immutable';
import {type Moment} from 'moment-timezone';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type IClosingDay} from './types';

const domain = 'CLOSING_DAYS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (institutionId: string) => ({institutionId}),
    (response: {closingDays: List<IClosingDay>; behaviors: BehaviorsCollection}) => ({response}),
);

export const {
    action: addClosingDays,
    success: addClosingDaysSuccess,
    failed: addClosingDaysFailed,
} = createAction(
    `${domain}/ADD_CLOSING_DAYS`,
    (institutionId: string, startDay: Moment, endDay: Moment, reason: string, dayType: number) => ({
        institutionId,
        startDay,
        endDay,
        reason,
        dayType,
    }),
    (closingDays: IClosingDay[]) => ({closingDays}),
);

export const {
    action: deleteClosingDay,
    success: deleteClosingDaySuccess,
    failed: deleteClosingDayFailed,
    aborted: deleteClosingDayAborted,
} = createAction(
    `${domain}/DELETE_CLOSING_DAY`,
    (closingDayId: string) => ({closingDayId}),
    (closingDayId: string) => ({closingDayId}),
    (closingDayId: string) => ({closingDayId}),
    (closingDayId: string) => ({closingDayId}),
);

export const {
    action: deleteClosingInterval,
    success: deleteClosingIntervalSuccess,
    failed: deleteClosingIntervalFailed,
    aborted: deleteClosingIntervalAborted,
} = createAction(
    `${domain}/DELETE_CLOSING_INVERVAL`,
    (closingDays: List<IClosingDay>) => ({closingDays}),
    (closingDays: List<IClosingDay>) => ({closingDays}),
    (closingDays: List<IClosingDay>) => ({closingDays}),
    (closingDays: List<IClosingDay>) => ({closingDays}),
);
